import wrapWithProvider from './src/store';

export const wrapRootElement = wrapWithProvider;